/* K Junction – "Complete the look" / "You may also like" on the product page: same product cards as the collection page */
(function () {
  'use strict';
  var sec = document.querySelector('[data-kjp-ctl]');
  var row = document.querySelector('[data-kjp-ctl-row]');
  if (!sec || !row) return;
  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  if (!handle) return;

  var pageSize = function () { return window.KJProduct && window.KJProduct.state && window.KJProduct.state.size; };
  var follow = function () { if (window.KJCards) window.KJCards.follow(row, pageSize()); };

  fetch('/products/' + handle + '?section_id=kj-ctl', { credentials: 'same-origin' })
    .then(function (r) { return r.text(); })
    .then(function (t) {
      var box = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-kj-ctl-cards]');
      if (!box || !box.querySelector('[data-kjc]')) return;
      row.classList.add('kjups');
      row.innerHTML = box.innerHTML;
      sec.classList.remove('kj-hide');
      if (window.KJCards) window.KJCards.hydrate(row);
      follow();
    })
    .catch(function () {});

  // cards follow the size picked on the page until the shopper picks one on a card
  var sizes = document.querySelector('[data-sizes]');
  if (sizes) sizes.addEventListener('click', function () { setTimeout(follow, 0); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-kjs] [data-kjs-select]')) setTimeout(follow, 0); });
})();
